import { db, firebaseNow } from './firebaseConfig';
import I18n from 'core/I18n/I18n';
import keyEnum from 'core/I18n/KeyEnum';
import EntityEnum from './EntityEnum';
import { getItem, addItem, deleteItem, updateItem, execute, executeAndFormat } from './firebaseFunctions';
import { groupReference } from 'core/database/user';
import { normalizeCombo } from 'core/utils/Utils';
import { userReference } from './user';
import Moment from 'moment';
import { emailRegex } from './validator/Regex';


export const addQuiz = async (item) => {
    // return addItem("Quiz", item);
}

export const getAllQuiz = ({scope, startDate, endDate, id, hasPower, user}) => {
    const allQuiz = getQuiz({scope, startDate, endDate, id, hasPower, user});
    const allMyQuiz = getQuiz({scope, startDate, endDate, id, hasPower, user, isMyQuiz: true})

    return Promise.all([allQuiz, allMyQuiz]).then(all => {
        const data = [];
        if(all){
            all.map(arrAllData => {
                if(arrAllData){
                    arrAllData.map(arrData => {
                        if(data.findIndex(item => item.id === arrData.id) === -1){
                            data.push(arrData);
                        }
                    })
                }
            })
        }

        return data;
    })
}

export const getQuiz = async ({ scope, startDate, endDate, id, hasPower, user, isMyQuiz }) => {
    let table = db.collection("Quiz").where("active", "==", true).where("isEvaluation", "==", false);

    if(!id && !hasPower){
        if(isMyQuiz){
            table = table.where("user", '==', user && userReference(user));
        } else {
            table = table.where("users", 'array-contains', { user: user && userReference(user) });
        }
    }

    if (startDate) {
        table = table.where("date", ">=", Moment(startDate, 'DD-MM-YYYY').toDate());
    }

    if (endDate) {
        table = table.where("date", "<=", Moment(endDate, 'DD-MM-YYYY').toDate());
    }

    if (scope && scope.value) {
        table = table.where("group", "==", groupReference(scope));
    } else if (id) {
        table = db.collection("Quiz").doc(id);
    } else {
        throw new Error(I18n[keyEnum.groupFieldRequired]);
    }

    return executeAndFormat(table, [{ key: 'group'}, { key: 'template' }, { key: 'user' }], [{ key: 'users', idField: 'user' }], (quizItem => {
        quizItem.date = { ...quizItem.date };
    }));
}

export const deleteQuiz = async (id) => {
    return deleteItem("Quiz", id);
}

export const updateQuiz = async (item) => {
    let { name, description } = item;

    const groups = [];
    item.groups.map(item => {
        groups.push({ group: groupReference(item) })
    })
    //descrição não pode ser nulo
    description = description ? description : "";

    return addItem("Quiz", { name, description, groups });
}

export const addOrUpdate = async (item) => {
    let { id, group, user } = item;

    const users = [];
    if (item.users) {
        if(user){
            const hasUserId = item.users.findIndex(item => item.value === user.id) >= 0;
            if(!hasUserId){
                users.push({ user: userReference({value: user.id}) })
            }
        }
        item.users.map(item => {
            if(emailRegex.test(item.value)){
                users.push({ user: item.value })
            } else {
                users.push({ user: userReference(item) })
            }
        });
    }

    const data = { ...item, users };
    if (id) {
        data['id'] = id;
    }
    if (group) {
        data['group'] = groupReference(group);
    }

    if (user) {
        data['user'] = userReference({value: user.id});
    }

    if (id) {
        return updateItem("Quiz", data);
    } else {
        return addItem("Quiz", { ...data, date: new Date(), isEvaluation: false });
    }
}

export const sendEmails = async (emails, description) => {
    // return fetch(`https://us-central1-aqto-360.cloudfunctions.net/api3/inviteAnswer?invite=${id}&emails=${emails} http://localhost:5000/aqto-360/us-central1/api3/inviteAnswer`);
    return fetch(`https://us-central1-aqto-360.cloudfunctions.net/api3/inviteAnswer?emails=${emails}&description=${description}`);
}